'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _LabelledInputComponent = require('../../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SelectComponent = require('../../../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _TextInputComponent = require('../../../components/input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _SectionHeaderComponent = require('../../../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _ButtonControllerComponent = require('../../../components/common/dynamic/ButtonControllerComponent');

var _ButtonControllerComponent2 = _interopRequireDefault(_ButtonControllerComponent);

var _MshApplicantComponent = require('../../../components/common/MshApplicantComponent');

var _MshApplicantComponent2 = _interopRequireDefault(_MshApplicantComponent);

var _ExpatQuoteComponent = require('../../../components/common/ExpatQuoteComponent');

var _ExpatQuoteComponent2 = _interopRequireDefault(_ExpatQuoteComponent);

var _EmailQuoteButtonComponent = require('../../../components/input/EmailQuoteButtonComponent');

var _EmailQuoteButtonComponent2 = _interopRequireDefault(_EmailQuoteButtonComponent);

var _DatePickerComponent = require('../../../components/input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _CurrencyInputComponent = require('../../../components/input/CurrencyInputComponent');

var _CurrencyInputComponent2 = _interopRequireDefault(_CurrencyInputComponent);

var _formConfiguration = require('../../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _application = require('../../../transformers/msh/global2go/application');

var _application2 = _interopRequireDefault(_application);

var _dates = require('../../../transformers/msh/global2go/dates');

var _dates2 = _interopRequireDefault(_dates);

var _MshActionCreators = require('../../../actions/MshActionCreators');

var _Quote = require('../../../validators/msh/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _translate = require('../../../language/translate');

var _MshErrorDivComponent = require('../../../components/common/MshErrorDivComponent');

var _MshErrorDivComponent2 = _interopRequireDefault(_MshErrorDivComponent);

var _InitialValues = require('../../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-no-bind */
/* eslint-disable prefer-arrow-callback */

/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable comma-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */

var fields = ['applicant.dob', 'application.email', 'application.additional_data.client_name', 'application.additional_data.nature_of_business', 'application.additional_data.currently_with_sunlife', 'application.additional_data.sunlife_benefits', 'application.additional_data.move_to_sunlife', 'application.additional_data.account_executive_name', 'application.additional_data.account_executive_phone', 'application.additional_data.renewal_date', 'application.additional_data.effective_date', 'application.additional_data.expiry_date', 'application.additional_data.group_benefits_advisor', 'application.additional_data.working_with_broker', 'application.additional_data.broker_name', 'application.additional_data.selling_agent_name', 'application.additional_data.broker_phone', 'application.additional_data.broker_email', 'application.additional_data.rotational_basis', 'application.additional_data.medical_coverage', 'application.additional_data.vision_coverage', 'application.additional_data.dental_coverage', 'application.additional_data.earnings', 'application.additional_data.basic_life_insurance_multiplier', 'application.additional_data.basic_life_flat_benefit_amount', 'application.additional_data.dependant_life_insurance', 'application.additional_data.optional_life_insurance', 'application.additional_data.adnd_insurance_multiplier', 'application.additional_data.adnd_insurance_flat_benefit_amount', 'application.additional_data.temporary_disability', 'application.additional_data.temporary_disability_benefit_duration', 'application.additional_data.temporary_disability_schedule_options', 'application.additional_data.temporary_disability_weekly_maximum', 'application.additional_data.long_term_disability', 'application.additional_data.long_term_disability_elimination_period', 'application.additional_data.long_term_disability_schedule_options', 'application.additional_data.permanent_total_disability_multiplier', 'application.additional_data.voluntary_life_insurance_amount', 'application.additional_data.voluntary_adnd_insurance_amount', 'application.additional_data.evacuation', 'application.additional_data.eap', 'application.additional_data.emergency_coverage', 'application.additional_data.applicant_count', 'applicants[].active', 'applicants[].dob', 'applicants[].first_name', 'applicants[].last_name', 'applicants[].gender', 'applicants[].additional_data.salary', 'applicants[].additional_data.salary_frequency', 'applicants[].additional_data.currency', 'applicants[].additional_data.occupation', 'applicants[].additional_data.occupational_class', 'applicants[].additional_data.occupational_class_voluntary_adnd', 'applicants[].additional_data.policy_type', 'applicants[].additional_data.medical_coverage', 'applicants[].additional_data.dental_coverage', 'applicants[].additional_data.orthodontia_coverage', 'applicants[].additional_data.home_country', 'applicants[].additional_data.host_country', 'applicants[].additional_data.rotational_basis', 'applicants[].additional_data.exposure_period', 'applicants[].additional_data.worldwide_coverage', 'applicants[].additional_data.dependent_count', 'applicants[].additional_data.dependents[]', 'applicants[].additional_data.dependents[].first_name', 'applicants[].additional_data.dependents[].last_name', 'applicants[].additional_data.dependents[].sex', 'applicants[].additional_data.dependents[].dob', 'applicants[].additional_data.dependents[].additional_data.relationship_to_applicant'];

/**
 * Renders the part of the form which generates a live quote.
 * @extends {Component}
 */

var GetQuoteComponent = function (_React$Component) {
  _inherits(GetQuoteComponent, _React$Component);

  function GetQuoteComponent(props) {
    _classCallCheck(this, GetQuoteComponent);

    var _this = _possibleConstructorReturn(this, (GetQuoteComponent.__proto__ || Object.getPrototypeOf(GetQuoteComponent)).call(this, props));

    _this.onChangeHook = _this.onChangeHook.bind(_this);
    _this.clickCalculatePremium = _this.clickCalculatePremium.bind(_this);
    _this.emailQuote = _this.emailQuote.bind(_this);
    _this.checkError = _this.checkError.bind(_this);
    _this.hideModal = _this.hideModal.bind(_this);
    _this.setDepCount = _this.setDepCount.bind(_this);
    _this.activateSection = _this.activateSection.bind(_this);
    _this.renderGroupTab = _this.renderGroupTab.bind(_this);
    _this.renderSectionFields = _this.renderSectionFields.bind(_this);
    _this.renderApplicantFields = _this.renderApplicantFields.bind(_this);
    _this.getComponentProps = _this.getComponentProps.bind(_this);

    _this.state = {
      showModal: true,
      updateState: true,
      applicantsStatus: []
    };

    _this.fieldTypes = {
      SelectComponent: _SelectComponent2.default,
      TextInputComponent: _TextInputComponent2.default,
      CurrencyInputComponent: _CurrencyInputComponent2.default,
      DatePickerComponent: _DatePickerComponent2.default,
      get: function get(name) {
        return Object.prototype.hasOwnProperty.call(this, name) ? this[name] : _TextInputComponent2.default;
      }
    };
    return _this;
  }

  _createClass(GetQuoteComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.scrollToTop && this.props.msh.quote.information != null) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.state.scrollToTop = false;
      }
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {
      this.state.scrollToTop = false;
      if (this.props.msh.quote.updatePremiumOnChange) {
        this.props.dispatch((0, _MshActionCreators.updateQuotes)(false, this.props));
      }
    }
  }, {
    key: 'getComponentProps',
    value: function getComponentProps(field) {
      var key = 'application.additional_data.' + field.field_key;
      if (this.formConfig[key] && this.formConfig[key].component_props) {
        var apiComponentProps = this.formConfig[key].component_props;
        return _extends({}, field.component_props, apiComponentProps);
      }
      return field.component_props;
    }
  }, {
    key: 'setMemberCount',
    value: function setMemberCount() {
      var displayedApplicants = this.props.fields.applicants ? this.props.fields.applicants.length : 0;
      var difference = displayedApplicants - this.props.fields.application.additional_data.applicant_count.value;

      if (difference > 0) {
        this.state.applicantsStatus = this.state.applicantsStatus.slice(0, -1 * difference);

        for (var i = 0; i < difference; i++) {
          this.props.fields.applicants.removeField();
        }
      } else {
        for (var _i = 0; _i > difference; _i--) {
          this.props.fields.applicants.addField();
          this.state.applicantsStatus.push({ active: false, header: (0, _translate.t)('Applicant') + ' ' + (displayedApplicants - _i + 1) });
        }
      }

      if (displayedApplicants === 0) {
        this.state.applicantsStatus[0].active = true;
      }

      this.onChangeHook();
      this.setState({ updateState: !this.state.updateState });
    }
  }, {
    key: 'setDepCount',
    value: function setDepCount(applicantIndex) {
      var displayedDependents = this.props.fields.applicants[applicantIndex].additional_data.dependents ? this.props.fields.applicants[applicantIndex].additional_data.dependents.length : 0;
      var difference = displayedDependents - this.props.fields.applicants[applicantIndex].additional_data.dependent_count.value;
      if (difference > 0) {
        for (var i = 0; i < difference; i++) {
          this.props.fields.applicants[applicantIndex].additional_data.dependents.removeField();
        }
      } else {
        for (var _i2 = 0; _i2 > difference; _i2--) {
          this.props.fields.applicants[applicantIndex].additional_data.dependents.addField();
        }
      }
      this.onChangeHook();
    }
  }, {
    key: 'clickCalculatePremium',
    value: function clickCalculatePremium() {
      this.state.scrollToTop = true;
      this.props.dispatch((0, _MshActionCreators.updateQuotes)(false, this.props));
    }
  }, {
    key: 'emailQuote',
    value: function emailQuote() {
      this.state.showModal = true;
      this.props.dispatch((0, _MshActionCreators.updateQuotes)(true, this.props));
    }
  }, {
    key: 'checkError',
    value: function checkError(fieldPath) {
      if (this.props.msh.quote.information) {
        var fieldErrors = this.props.msh.quote.information.filter(function (el) {
          return el.key === fieldPath;
        });
        return fieldErrors.length !== 0;
      }
      return false;
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'activateSection',
    value: function activateSection(sections, index) {
      sections.forEach(function (section) {
        section.active = false;
      });
      sections[index].active = true;
      this.setState({ updateState: !this.state.updateState });
    }
  }, {
    key: 'renderGroupTab',
    value: function renderGroupTab(sections, fieldFunction) {
      return _react2.default.createElement(
        'div',
        { className: 'section-container' },
        _react2.default.createElement(
          'div',
          { className: 'tabs-container' },
          sections.map(function (section, sectionIndex) {
            return _react2.default.createElement(
              'div',
              {
                className: 'tab ' + (section.active ? 'active' : ''),
                onClick: this.activateSection.bind(this, sections, sectionIndex)
              },
              _react2.default.createElement(
                'p',
                { className: 'tab-text' },
                (0, _translate.t)(section.header)
              )
            );
          }, this)
        ),
        sections.map(function (section, sectionIndex) {
          return section.active ? _react2.default.createElement(
            'div',
            { className: 'fields-container' },
            fieldFunction(section, sectionIndex)
          ) : null;
        }, this)
      );
    }
  }, {
    key: 'renderSectionFields',
    value: function renderSectionFields(section, index) {
      return _react2.default.createElement(
        'div',
        null,
        section.fields.map(function (field, sectionIndex) {
          var _this2 = this;

          var showFlag = true;
          field.component_props.onChangeHook = field.component_props.onChange ? function () {
            return _this2[field.component_props.onChange]();
          } : null;

          if (field.show_if !== undefined) {
            field.show_if.map(function (showIfField, fieldIndex) {
              if (showIfField.value.indexOf(this.props.fields.application.additional_data[showIfField.key_path].value) === -1) {
                showFlag = false;
                return null;
              }
              return null;
            }, this);
          }
          return showFlag ? _react2.default.createElement(_LabelledInputComponent2.default, {
            key: sectionIndex,
            inputId: field.id,
            inputLabel: field.name,
            inputComponent: this.fieldTypes.get(field.component_type),
            inputComponentField: this.props.fields.application.additional_data[field.field_key],
            inputComponentProps: this.getComponentProps(field),
            leftIndent: field.show_if,
            hasExpandableHint: field.hasExpandableHint,
            expandableHintId: field.expandableHintId,
            expandableHintTitle: field.hasExpandableHint ? this.formConfig[field.expandableHintPath].title : null,
            expandableHintContent: field.hasExpandableHint ? this.formConfig[field.expandableHintPath].hint : null,
            expandableHintIsRawHtml: field.expandableHintIsRawHtml,
            hasError: this.checkError('application.additional_data.' + field.field_key)
          }) : null;
        }, this)
      );
    }
  }, {
    key: 'renderApplicantFields',
    value: function renderApplicantFields(section, index) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_MshApplicantComponent2.default, {
          applicant: this.props.fields.applicants[index],
          formValues: this.props.values,
          dates: _dates2.default,
          onChangeHook: this.onChangeHook,
          setDepCount: this.setDepCount,
          checkError: this.checkError,
          key: index,
          dynamicFieldIndex: index,
          rotationalBasis: this.props.fields.application.additional_data.rotational_basis.value === '1',
          medicalPlanOptions: this.props.fields.application.additional_data.medical_coverage,
          visionPlanOptions: this.props.fields.application.additional_data.dental_coverage,
          dentalPlanOptions: this.props.fields.application.additional_data.dental_coverage,
          salaryFrequency: true,
          inputComponentField: this.props.fields.applicants[index],
          formConfig: this.formConfig,
          isGroupForm: false,
          applicantIndex: index,
          formName: this.props.formName
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'form-horizontal' },
        _react2.default.createElement(
          'div',
          null,
          this.renderGroupTab(_config2.default.clients.msh[this.props.formName].form_config, this.renderSectionFields),
          this.renderGroupTab(this.state.applicantsStatus, this.renderApplicantFields)
        ),
        _react2.default.createElement(_MshErrorDivComponent2.default, {
          errors: this.props.msh.quote.information
        }),
        this.props.msh.quote.questionnaire ? _react2.default.createElement(
          'div',
          { className: 'div-center padding-topbottom-20 margin-topbottom-20 alert alert-info' },
          (0, _translate.t)(_config2.default.messages.questionnaire_required)
        ) : null,
        this.props.showPremium ? _react2.default.createElement(
          'div',
          { className: 'div-center padding-topbottom-20' },
          _react2.default.createElement(
            _reactBootstrap.Button,
            {
              bsStyle: 'primary',
              className: 'ingle-form-submit-button button',
              type: 'submit',
              onClick: this.clickCalculatePremium
            },
            (0, _translate.t)(_config2.default.messages.calculate_premium)
          ),
          _react2.default.createElement(_ExpatQuoteComponent2.default, {
            quoteAmount: this.props.msh.quote.price,
            quoteDetails: null
          }),
          _react2.default.createElement(_LabelledInputComponent2.default, {
            inputId: 'email',
            inputLabel: 'Email',
            inputComponent: _TextInputComponent2.default,
            inputComponentField: this.props.fields.application.email,
            inputComponentProps: {
              type: 'text'
            }
          })
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'div-center padding-topbottom-20' },
          _react2.default.createElement(
            _EmailQuoteButtonComponent2.default,
            {
              isFormSubmitting: this.props.submitting,
              isFormInvalid: false,
              onClickAction: this.emailQuote,
              disabled: this.props.showPremium && (!this.props.msh.quote.price || !this.props.fields.application.email.value)
            },
            (0, _translate.t)(_config2.default.messages.submit_application)
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.state.showModal && Boolean(this.props.msh.quote.reference) },
          _react2.default.createElement(
            'div',
            { className: 'modal-button' },
            _react2.default.createElement(
              'h2',
              { className: 'padding-left quote-price-display' },
              (0, _translate.t)(_config2.default.messages.application_success)
            ),
            _react2.default.createElement(
              'div',
              { className: '' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary button margin-left', onClick: this.hideModal },
                (0, _translate.t)(_config2.default.messages.close)
              )
            )
          )
        )
      );
    }
  }]);

  return GetQuoteComponent;
}(_react2.default.Component);

GetQuoteComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  trackingCode: _react2.default.PropTypes.string,
  formName: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    msh: state.msh,
    formConfig: state.formConfig.config
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(GetQuoteComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/msh/global2go/GetQuoteContainer.jsx
// module id = 411
// module chunks = 0